import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store/'

import Login from '@/views/Login.vue'
import SignUp from '@/views/SignUp.vue'
import ActivateAccount from '@/views/ActivateAccount.vue'
import PasswordReset from '@/views/PasswordReset.vue'
import NewOrder from '@/views/NewOrder.vue'
import Contact from '@/views/Contact.vue'

import DashboardBase from '@/views/dashboard/Base.vue'
import DashboardHome from '@/views/dashboard/Home.vue'
import DashboardContact from '@/views/dashboard/Contact.vue'
import DashboardNewOrder from '@/views/dashboard/NewOrder.vue'

import DashboardOrderBase from '@/views/dashboard/order/Base.vue'
import DashboardOrderList from '@/views/dashboard/order/List.vue'
import DashboardOrderDetail from '@/views/dashboard/order/Detail.vue'

import DashboardAccountBase from '@/views/dashboard/account/Base.vue'
import DashboardAccountSettings from '@/views/dashboard/account/Settings.vue'

Vue.use(VueRouter)

const PUBLIC_PATHS = ['Login', 'SignUp', 'NewOrder', 'PasswordReset', 'ActivateAccount', 'ContactUs']
const ANONYMOUS_ONLY_PATHS = ['Login', 'SignUp', 'NewOrder', 'PasswordReset', 'ActivateAccount', 'ContactUs']

const routes = [  
  {
    path: '/login/activate/:uid/:token',
    name: 'ActivateAccount',
    component: ActivateAccount,
    props: true
  },
  {
    path: '/login/reset/:uid/:token',
    name: 'PasswordReset',
    component: PasswordReset,
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: SignUp,
  },
  {
    path: '/new-order',
    name: 'NewOrder',
    component: NewOrder,
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: Contact,
  },
  {
    path: '/dashboard',
    component: DashboardBase,
    children: [
      { path: '', name: "Home", component: DashboardHome },
      { path: 'new-order', name: "New Order", component: DashboardNewOrder },
      { path: 'contact-us', name: "Contact Us", component: DashboardContact },
      { 
        path: 'orders', 
        component: DashboardOrderBase,
        children: [
          { path: '', name: "Order History", component: DashboardOrderList },
          { path: ':id', name: "Order Details", component: DashboardOrderDetail, props: true },
        ]
      },
      { 
        path: 'account', 
        component: DashboardAccountBase,
        children: [
          { path: '', name: "Account Settings", component: DashboardAccountSettings },
        ]
      },
      // ...other sub routes
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const anonymousRouteCheck = (name) => (
  ANONYMOUS_ONLY_PATHS.includes(name) &&
  store.getters['auth/isAuthenticated']
)

const authenticatedRouteCheck = (name) => (
  !PUBLIC_PATHS.includes(name) &&
  !store.getters['auth/isAuthenticated']
)

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    next('/dashboard')
  } else if (authenticatedRouteCheck(to.name)) {
    next(`/login?next=${to.path}`);
  } else if (anonymousRouteCheck(to.name)) {
    if (to.path === "/new-order") {
      next(`/dashboard${to.fullPath}`);
    } else if (to.path === "/contact-us") {
      next(`/dashboard${to.fullPath}`);
    } else {
      next('/dashboard');
    }
  } else {
    next();
  }
});

export default router
